/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_PriceInputs */

const en_admin_resources_price = /** @type {(inputs: Admin_Resources_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

const de_admin_resources_price = /** @type {(inputs: Admin_Resources_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis`)
};

const es_admin_resources_price = /** @type {(inputs: Admin_Resources_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio`)
};

const fr_admin_resources_price = /** @type {(inputs: Admin_Resources_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix`)
};

/** @type {(inputs: Admin_Resources_PriceInputs) => LocalizedString} */
const it_admin_resources_price = en_admin_resources_price;

/** @type {(inputs: Admin_Resources_PriceInputs) => LocalizedString} */
const pt_br2_admin_resources_price = en_admin_resources_price;

/** @type {(inputs: Admin_Resources_PriceInputs) => LocalizedString} */
const pl_admin_resources_price = en_admin_resources_price;

/** @type {(inputs: Admin_Resources_PriceInputs) => LocalizedString} */
const hu_admin_resources_price = en_admin_resources_price;

/** @type {(inputs: Admin_Resources_PriceInputs) => LocalizedString} */
const ro_admin_resources_price = en_admin_resources_price;

/**
* | output |
* | --- |
* | "Price" |
*
* @param {Admin_Resources_PriceInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_price = /** @type {((inputs?: Admin_Resources_PriceInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_PriceInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_price(inputs)
	if (locale === "de") return de_admin_resources_price(inputs)
	if (locale === "es") return es_admin_resources_price(inputs)
	if (locale === "fr") return fr_admin_resources_price(inputs)
	if (locale === "it") return it_admin_resources_price(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_price(inputs)
	if (locale === "pl") return pl_admin_resources_price(inputs)
	if (locale === "hu") return hu_admin_resources_price(inputs)
	return ro_admin_resources_price(inputs)
});
export { admin_resources_price as "admin.resources.price" }